import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface LoadingState {
    activeLoads: number,
    message: string
}

const initialState: LoadingState = {
    activeLoads: 0,
    message: 'Loading'
}

export const loadingSlice = createSlice({
    name: 'loading',
    initialState,
    reducers: {
        resetLoading: (state) => {
            state.activeLoads = 0
            state.message = 'Loading'
        },
        setLoading: (state, action: PayloadAction<{ loading: boolean, message: string }>) => {
            if (action.payload.loading) {
                state.activeLoads = state.activeLoads + 1
                state.message = action.payload.message
            } else {
                if (state.activeLoads > 0) {
                    state.activeLoads = state.activeLoads - 1
                    state.message = action.payload.message
                }
            }
        }
    },
})

export const { resetLoading, setLoading } = loadingSlice.actions
export default loadingSlice.reducer